import gql from 'graphql-tag';
import { MINIMAL_DISCUSSION_MESSAGE_FRAGMENT } from '../discussion/fragment';

export const COMPAIGN_FRAGMENT = gql`
  fragment CompaignFragment on Compaign {
    id
    title
    createdAt
    message {
      ...MinimalDiscussionMessageFragment
    }
    users {
      id
      avatarUrl
      firstName
      lastName
    }
  }
  ${MINIMAL_DISCUSSION_MESSAGE_FRAGMENT}
`;

export const MINIMAL_COMPAIGN_FRAGMENT = gql`
  fragment MinimalCompaignFragment on Compaign {
    id
    title
    createdAt
    message {
      id
      content {
        id
        text
      }
    }
  }
`;
